import { Component, Inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import * as L from "leaflet";

@Component({
  selector: "app-modal-map",
  standalone: true,
  imports: [MatButtonModule, MatDialogModule],
  templateUrl: "./modal-map.component.html",
  styleUrl: "./modal-map.component.scss",
})
export class ModalMapComponent {
  map: L.Map;
  marker = null;
  markerBounds: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<ModalMapComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngAfterViewInit() {
    this.initMap();
  }

  private initMap(): void {
    this.map = L.map("mapDetailTo").fitWorld();

    const tiles = L.tileLayer(
      "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      {
        maxZoom: 19,
        attribution:
          '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      }
    );

    tiles.addTo(this.map);

    if (this.data.type == "H") {
      if (
        Array.isArray(this.data.element.visits) &&
        this.data.element.visits.length > 0
      ) {
        this.updateMap(this.data.element.visits);
      }
    } else {
      /* Leyenda */
      var legend = (L.control as any)({ position: "topright" });
      legend.onAdd = (map) => {
        var div = L.DomUtil.create("div", "legendMap"),
          labels = ["<strong>Leyenda</strong>"],
          categories = ["APP", "ERP"];

        div.innerHTML += labels.push(
          `
          <div style="display: inline-block; width: 35px; height: 30px;">
            <svg fill=#279e2b viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
              <g>
                <polyline xmlns="http://www.w3.org/2000/svg" points="235.961,227.066 235.961,418.382 255.958,501.98 276.039,421.759 276.039,227.066" fill="#000000"/>
                <circle xmlns="http://www.w3.org/2000/svg" cx="256" cy="119.463" r="109.444" fill="#279e2b"/>
                <path xmlns="http://www.w3.org/2000/svg" d="M375.459,119.459C375.459,53.589,321.87,0,256,0S136.541,53.589,136.541,119.459c0,55.491,38.033,102.265,89.401,115.627v183.295c0,0.786,0.092,1.567,0.275,2.332l19.997,83.598c1.073,4.49,5.076,7.664,9.692,7.689c0.018,0,0.035,0,0.054,0c4.594,0,8.602-3.126,9.719-7.587l20.081-80.221c0.198-0.796,0.3-1.612,0.3-2.433V235.086C337.426,221.724,375.459,174.951,375.459,119.459z M266.02,420.524l-9.84,39.312L245.98,417.2V238.495c3.304,0.276,6.645,0.424,10.02,0.424s6.715-0.148,10.02-0.424V420.524z M256,218.879c-54.82,0-99.42-44.6-99.42-99.42s44.6-99.42,99.42-99.42s99.42,44.6,99.42,99.42S310.82,218.879,256,218.879z" fill="#000000"/>
                <path xmlns="http://www.w3.org/2000/svg" d="M256,39.577c-44.047,0-79.882,35.835-79.882,79.882c0,5.534,4.487,10.02,10.02,10.02s10.02-4.486,10.02-10.02c0-32.997,26.845-59.843,59.843-59.843c5.533,0,10.02-4.486,10.02-10.02S261.533,39.577,256,39.577z" fill="#000000"/>
                <path xmlns="http://www.w3.org/2000/svg" d="M186.238,136.767h-0.2c-5.533,0-10.02,4.486-10.02,10.02c0,5.534,4.487,10.02,10.02,10.02h0.2c5.533,0,10.02-4.486,10.02-10.02C196.257,141.253,191.771,136.767,186.238,136.767z" fill="#000000"/>
                <text x="50%" y="30%" text-anchor="middle" fill="#ffffff" stroke="#ffffff" stroke-width="0.5px" dy=".25em" alignment-baseline="baseline" font-size="190"></text>
              </g>
            </svg>
          </div>
          ` + (categories[0] ? categories[0] : "+")
        );
        div.innerHTML += labels.push(
          `
          <div style="display: inline-block; width: 35px; height: 30px;">
            <svg fill=#27499e viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
              <g>
                <polyline xmlns="http://www.w3.org/2000/svg" points="235.961,227.066 235.961,418.382 255.958,501.98 276.039,421.759 276.039,227.066" fill="#000000"/>
                <circle xmlns="http://www.w3.org/2000/svg" cx="256" cy="119.463" r="109.444" fill="#27499e"/>
                <path xmlns="http://www.w3.org/2000/svg" d="M375.459,119.459C375.459,53.589,321.87,0,256,0S136.541,53.589,136.541,119.459c0,55.491,38.033,102.265,89.401,115.627v183.295c0,0.786,0.092,1.567,0.275,2.332l19.997,83.598c1.073,4.49,5.076,7.664,9.692,7.689c0.018,0,0.035,0,0.054,0c4.594,0,8.602-3.126,9.719-7.587l20.081-80.221c0.198-0.796,0.3-1.612,0.3-2.433V235.086C337.426,221.724,375.459,174.951,375.459,119.459z M266.02,420.524l-9.84,39.312L245.98,417.2V238.495c3.304,0.276,6.645,0.424,10.02,0.424s6.715-0.148,10.02-0.424V420.524z M256,218.879c-54.82,0-99.42-44.6-99.42-99.42s44.6-99.42,99.42-99.42s99.42,44.6,99.42,99.42S310.82,218.879,256,218.879z" fill="#000000"/>
                <path xmlns="http://www.w3.org/2000/svg" d="M256,39.577c-44.047,0-79.882,35.835-79.882,79.882c0,5.534,4.487,10.02,10.02,10.02s10.02-4.486,10.02-10.02c0-32.997,26.845-59.843,59.843-59.843c5.533,0,10.02-4.486,10.02-10.02S261.533,39.577,256,39.577z" fill="#000000"/>
                <path xmlns="http://www.w3.org/2000/svg" d="M186.238,136.767h-0.2c-5.533,0-10.02,4.486-10.02,10.02c0,5.534,4.487,10.02,10.02,10.02h0.2c5.533,0,10.02-4.486,10.02-10.02C196.257,141.253,191.771,136.767,186.238,136.767z" fill="#000000"/>
                <text x="50%" y="30%" text-anchor="middle" fill="#ffffff" stroke="#ffffff" stroke-width="0.5px" dy=".25em" alignment-baseline="baseline" font-size="190"></text>
              </g>
            </svg>
          </div>
          ` + (categories[1] ? categories[1] : "+")
        );
        div.innerHTML = labels.join("<br>");
        return div;
      };
      legend.addTo(this.map);
      const geoPoint = this.data.element.geoPoint || [];
      const addressPoint =
        this.data.element.shipTo?.addresses[0]?.geolocationPoint || [];

      let arrayMap = [];
      if (geoPoint.length === 2) {
        arrayMap.push({
          latitude: geoPoint[0],
          longitude: geoPoint[1],
          type: "APP",
        });
      }
      if (addressPoint.length === 2) {
        arrayMap.push({
          latitude: addressPoint[0],
          longitude: addressPoint[1],
          type: "ERP",
        });
      }
      this.updateMapDetail(arrayMap);
    }
  }

  updateMap(data) {
    for (let pinItem = 0; pinItem < data.length; pinItem++) {
      let color_route = "#279e2b";
      var routeIcon = L.divIcon({
        html: `
          <svg fill=${color_route} viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
          <g>
          <polyline xmlns="http://www.w3.org/2000/svg" style="" points="235.961,227.066 235.961,418.382 255.958,501.98 276.039,421.759 276.039,227.066 " fill="#000000" data-original="#d8d7da" class=""/>
          <circle xmlns="http://www.w3.org/2000/svg" style="" cx="256" cy="119.463" r="109.444" fill="${color_route}" data-original="#ff5d5d" class=""/>
          <path xmlns="http://www.w3.org/2000/svg" d="M375.459,119.459C375.459,53.589,321.87,0,256,0S136.541,53.589,136.541,119.459c0,55.491,38.033,102.265,89.401,115.627  v183.295c0,0.786,0.092,1.567,0.275,2.332l19.997,83.598c1.073,4.49,5.076,7.664,9.692,7.689c0.018,0,0.035,0,0.054,0  c4.594,0,8.602-3.126,9.719-7.587l20.081-80.221c0.198-0.796,0.3-1.612,0.3-2.433V235.086  C337.426,221.724,375.459,174.951,375.459,119.459z M266.02,420.524l-9.84,39.312L245.98,417.2V238.495  c3.304,0.276,6.645,0.424,10.02,0.424s6.715-0.148,10.02-0.424V420.524z M256,218.879c-54.82,0-99.42-44.6-99.42-99.42  s44.6-99.42,99.42-99.42s99.42,44.6,99.42,99.42S310.82,218.879,256,218.879z" fill="#000000" data-original="#000000" style="" class=""/>
          <path xmlns="http://www.w3.org/2000/svg" d="M256,39.577c-44.047,0-79.882,35.835-79.882,79.882c0,5.534,4.487,10.02,10.02,10.02s10.02-4.486,10.02-10.02  c0-32.997,26.845-59.843,59.843-59.843c5.533,0,10.02-4.486,10.02-10.02S261.533,39.577,256,39.577z" fill="#000000" data-original="#000000" style="" class=""/>
          <path xmlns="http://www.w3.org/2000/svg" d="M186.238,136.767h-0.2c-5.533,0-10.02,4.486-10.02,10.02c0,5.534,4.487,10.02,10.02,10.02h0.2  c5.533,0,10.02-4.486,10.02-10.02C196.257,141.253,191.771,136.767,186.238,136.767z" fill="#000000" data-original="#000000" style="" class=""/>
          <text x="50%" y="30%" text-anchor="middle" fill="#ffffff" stroke="#ffffff" stroke-width="0.5px" dy=".25em" alignment-baseline="baseline" font-size="190">${pinItem + 1}</text>
          </g>
          </svg>`,
        iconSize: [35, 30],
        iconAnchor: [5, 10],
        className: "leaflet-marker",
      });

      if (data[pinItem].geoPoint[0] != "" && data[pinItem].geoPoint[1] != "") {
        var marker = L.marker(
          [
            parseFloat(data[pinItem].geoPoint[0]),
            parseFloat(data[pinItem].geoPoint[1]),
          ],
          { icon: routeIcon }
        ).addTo(this.map);
      }

      var latLngs = [marker.getLatLng()];
      this.markerBounds.push(L.latLngBounds(latLngs));
      this.map.fitBounds(this.markerBounds);
    }
  }

  updateMapDetail(data) {
    for (let pinItem = 0; pinItem < data.length; pinItem++) {
      let color_route = data[pinItem].type == "ERP" ? "#27499e" : "#279e2b";
      var routeIcon = L.divIcon({
        html: `
          <svg fill=${color_route} viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
          <g>
          <polyline xmlns="http://www.w3.org/2000/svg" style="" points="235.961,227.066 235.961,418.382 255.958,501.98 276.039,421.759 276.039,227.066 " fill="#000000" data-original="#d8d7da" class=""/>
          <circle xmlns="http://www.w3.org/2000/svg" style="" cx="256" cy="119.463" r="109.444" fill="${color_route}" data-original="#ff5d5d" class=""/>
          <path xmlns="http://www.w3.org/2000/svg" d="M375.459,119.459C375.459,53.589,321.87,0,256,0S136.541,53.589,136.541,119.459c0,55.491,38.033,102.265,89.401,115.627  v183.295c0,0.786,0.092,1.567,0.275,2.332l19.997,83.598c1.073,4.49,5.076,7.664,9.692,7.689c0.018,0,0.035,0,0.054,0  c4.594,0,8.602-3.126,9.719-7.587l20.081-80.221c0.198-0.796,0.3-1.612,0.3-2.433V235.086  C337.426,221.724,375.459,174.951,375.459,119.459z M266.02,420.524l-9.84,39.312L245.98,417.2V238.495  c3.304,0.276,6.645,0.424,10.02,0.424s6.715-0.148,10.02-0.424V420.524z M256,218.879c-54.82,0-99.42-44.6-99.42-99.42  s44.6-99.42,99.42-99.42s99.42,44.6,99.42,99.42S310.82,218.879,256,218.879z" fill="#000000" data-original="#000000" style="" class=""/>
          <path xmlns="http://www.w3.org/2000/svg" d="M256,39.577c-44.047,0-79.882,35.835-79.882,79.882c0,5.534,4.487,10.02,10.02,10.02s10.02-4.486,10.02-10.02  c0-32.997,26.845-59.843,59.843-59.843c5.533,0,10.02-4.486,10.02-10.02S261.533,39.577,256,39.577z" fill="#000000" data-original="#000000" style="" class=""/>
          <path xmlns="http://www.w3.org/2000/svg" d="M186.238,136.767h-0.2c-5.533,0-10.02,4.486-10.02,10.02c0,5.534,4.487,10.02,10.02,10.02h0.2  c5.533,0,10.02-4.486,10.02-10.02C196.257,141.253,191.771,136.767,186.238,136.767z" fill="#000000" data-original="#000000" style="" class=""/>
          </g>
          </svg>`,
        iconSize: [30, 30],
        iconAnchor: [5, 30],
        className: "leaflet-marker",
      }); // texto despues de path <text x="50%" y="50%" text-anchor="middle" fill="#ffffff" stroke="#ffffff" stroke-width="1px" dy=".25em" alignment-baseline="baseline" font-size="80">${data[pinItem].type}</text>

      var marker = L.marker(
        [
          parseFloat(data[pinItem].latitude),
          parseFloat(data[pinItem].longitude),
        ],
        { icon: routeIcon }
      ).addTo(this.map);
      //marker.bindPopup(`<b>${data[pinItem].customerCode}</b> <br> ${data[pinItem].customerName}`)

      var latLngs = [marker.getLatLng()];
      this.markerBounds.push(L.latLngBounds(latLngs));
      this.map.fitBounds(this.markerBounds);
    }
  }

  onClose() {
    this.dialogRef.close("Close");
  }
}
